module.exports = __webpack_public_path__ + "static/img/logo_white.b9ad4438.svg";